export default "__VITE_ASSET__nkzRu9fw__"